import { IMeter, ISite } from '../site/interface';
import { IProduct } from '../product/interface';

export enum EnrollmentStatus {
    'NOT_SUBMITTED' = 'Not Submitted',
    'SUBMITTED' = 'Submitted',
    'ENROLLED' = 'Enrolled',
    'INELIGIBLE_FINAL' = 'Ineligible-Final',
    'INELIGIBLE_FOLLOW_UP' = 'Ineligible-Follow-up',
    'NOT_PARTICIPATING' = 'Not Participating',
    'DE_ENROLLED' = 'De-enrolled',
    'PRE_SUBMISSION' = 'Pre-Submission',
    'ENROLLMENT_ID_CHANGED' = 'Enrollment ID Changed',
    'MOVED_PROGRAMS' = 'Moved Programs',
    'CLOSED' = 'Closed',
}

export const ENROLLMENT_STATUS_TEXT_MAP: { [key: string]: string } = {
    [EnrollmentStatus.ENROLLED]: 'Enrolled',
    [EnrollmentStatus.DE_ENROLLED]: 'De-Enrolled',
    [EnrollmentStatus.INELIGIBLE_FOLLOW_UP]: 'Ineligible-Follow Up',
    [EnrollmentStatus.SUBMITTED]: 'Submitted',
    [EnrollmentStatus.NOT_SUBMITTED]: 'Not Submitted',
    [EnrollmentStatus.PRE_SUBMISSION]: 'Pre-Submission',
    [EnrollmentStatus.NOT_PARTICIPATING]: 'Not Participating',
    [EnrollmentStatus.INELIGIBLE_FINAL]: 'Ineligible-Final',
    [EnrollmentStatus.ENROLLMENT_ID_CHANGED]: 'Enrollment ID Changed',
};

export const ENROLLMENT_STATUS_FILTER_VALUES = [
    { text: ENROLLMENT_STATUS_TEXT_MAP[EnrollmentStatus.ENROLLED], value: EnrollmentStatus.ENROLLED },
    { text: ENROLLMENT_STATUS_TEXT_MAP[EnrollmentStatus.DE_ENROLLED], value: EnrollmentStatus.DE_ENROLLED },
    { text: ENROLLMENT_STATUS_TEXT_MAP[EnrollmentStatus.INELIGIBLE_FOLLOW_UP], value: EnrollmentStatus.INELIGIBLE_FOLLOW_UP },
    { text: ENROLLMENT_STATUS_TEXT_MAP[EnrollmentStatus.SUBMITTED], value: EnrollmentStatus.SUBMITTED },
    { text: ENROLLMENT_STATUS_TEXT_MAP[EnrollmentStatus.NOT_SUBMITTED], value: EnrollmentStatus.NOT_SUBMITTED },
    { text: ENROLLMENT_STATUS_TEXT_MAP[EnrollmentStatus.PRE_SUBMISSION], value: EnrollmentStatus.PRE_SUBMISSION },
    { text: ENROLLMENT_STATUS_TEXT_MAP[EnrollmentStatus.NOT_PARTICIPATING], value: EnrollmentStatus.NOT_PARTICIPATING },
    { text: ENROLLMENT_STATUS_TEXT_MAP[EnrollmentStatus.INELIGIBLE_FINAL], value: EnrollmentStatus.INELIGIBLE_FINAL },
    { text: ENROLLMENT_STATUS_TEXT_MAP[EnrollmentStatus.ENROLLMENT_ID_CHANGED], value: EnrollmentStatus.ENROLLMENT_ID_CHANGED },
];

export interface IMeterEnrollment {
    salesforce_id: string;
    name: string;
    enrollment_id?: string;
    meter_salesforce_id?: string;
    meter?: IMeter;
    product_salesforce_id?: string;
    product: IProduct;
    product_name?: string;
    sites?: ISite[];
    opportunity_salesforce_id?: string;
    pjm_registration_id: string;
    enrollment_status: EnrollmentStatus;
    enrollment_start_date?: Date;
    enrollment_end_date?: Date;
    salesforce_submitted_at?: Date;
    salesforce_created_at: Date;
    salesforce_created_by: string;
    salesforce_updated_at?: Date;
    salesforce_updated_by?: string;

    previous_nomination?: number;
    current_nomination?: number;
    upcoming_nomination?: number;

    nomination_info?: INominationInfoDto;

    synced_at: Date;
    created_at: Date;
}

export class INominationInfoDetailDto {
    nomination_kw?: number;
    start_date?: string;
    end_date?: string;
}

export class INominationInfoDto {
    previous?: INominationInfoDetailDto;
    current?: INominationInfoDetailDto;
    upcoming?: INominationInfoDetailDto;
}
